document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.revive-pdp').forEach(function (root) {
    if (root.dataset.reviveInit === 'true') return;
    root.dataset.reviveInit = 'true';

    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('form[action^="/cart/add"]') || root.querySelector('.revive-pdp__form');
    var variantIdInput = root.querySelector('[id^="RevivePdpVariantId-"]');
    var priceEl = root.querySelector('[id^="RevivePrice-"]');
    var addLabel = root.querySelector('[data-add-label]');
    var addBtn = root.querySelector('.revive-pdp__add');
    var buyNowBtn = root.querySelector('[data-buy-now]');
    var optionGroups = root.querySelectorAll('.revive-pdp__option');
    var selected = {};
    var isSubmitting = false;

    optionGroups.forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      var activeBtn = group.querySelector('.revive-pdp__option-btn.is-selected');
      selected[idx] = activeBtn ? activeBtn.getAttribute('data-option-value') : null;
    });

    var preorder = addBtn && addBtn.getAttribute('data-preorder') === 'true';

    function missingGroup() {
      var missing = null;
      optionGroups.forEach(function (group) {
        if (!missing && !selected[group.getAttribute('data-option-index')]) missing = group;
      });
      return missing;
    }

    function showMissing(group) {
      group.classList.add('has-error');
      var err = group.querySelector('[data-option-error]');
      if (err) err.hidden = false;
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function findVariant() {
      if (missingGroup()) return null;
      return variants.find(function (v) {
        return Object.keys(selected).every(function (idx) {
          return v['option' + (parseInt(idx, 10) + 1)] === selected[idx];
        });
      });
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) {
        if (missingGroup()) {
          if (variantIdInput) variantIdInput.value = '';
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = 'SELECT A ' + (missingGroup().getAttribute('data-option-name') || 'OPTION').toUpperCase();
        }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (variant.available) {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = (preorder ? 'PRE-ORDER — ' : 'ADD TO CART — ') + money(variant.price);
      } else {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'SOLD OUT';
      }

      var mediaId = variant.featured_media ? variant.featured_media.id : null;
      if (mediaId) {
        root.querySelectorAll('.revive-pdp__media-img').forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-media-id') === String(mediaId));
        });
        root.querySelectorAll('.revive-pdp__thumb').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-thumb-for') === String(mediaId));
        });
      }
    }

    root.querySelectorAll('.revive-pdp__option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.revive-pdp__option');
        var idx = group.getAttribute('data-option-index');
        var value = btn.getAttribute('data-option-value');
        selected[idx] = value;
        group.querySelectorAll('.revive-pdp__option-btn').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        group.classList.remove('has-error');
        var errEl = group.querySelector('[data-option-error]');
        if (errEl) errEl.hidden = true;
        var labelSpan = group.querySelector('[data-selected-value-label]');
                if (labelSpan) labelSpan.textContent = String(value).toUpperCase();
        updateUI();
      });
    });

    root.querySelectorAll('.revive-pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-thumb-for');
        root.querySelectorAll('.revive-pdp__media-img').forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-media-id') === mediaId);
        });
        root.querySelectorAll('.revive-pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    root.querySelectorAll('[data-acc-toggle]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.revive-pdp__acc-item');
        var panel = item.querySelector('[data-acc-panel]');
        var icon = trigger.querySelector('[data-acc-icon]');
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        icon.textContent = isOpen ? '+' : '−';
      });
    });

    function addToCart() {
      if (isSubmitting) return Promise.reject('already submitting');
      isSubmitting = true;
      addBtn.disabled = true;
      var formData = new FormData(form);
      return fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .finally(function () {
          isSubmitting = false;
          addBtn.disabled = false;
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (isSubmitting) return;
        var missingForm = missingGroup();
        if (missingForm) { showMissing(missingForm); return; }
        addToCart()
          .then(function () {
            if (window.ReviveCart) { window.ReviveCart.refresh(); window.ReviveCart.open(); }
          })
          .catch(function (err) { console.error('Add to cart failed', err); });
      }, true);
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (isSubmitting) return;
        var missingBuy = missingGroup();
        if (missingBuy) { showMissing(missingBuy); return; }
        addToCart()
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) { console.error('Buy now failed', err); });
      });
    }
  });
});